import type { AppState } from '../science/types';

export type StoreListener = (state: Readonly<AppState>, previous: Readonly<AppState>) => void;

export class AppStore {
  private state: AppState;
  private listeners = new Set<StoreListener>();

  constructor(initial: AppState) {
    this.state = structuredClone(initial);
  }

  getState(): Readonly<AppState> {
    return this.state;
  }

  update(mutator: (draft: AppState) => void): void {
    const previous = structuredClone(this.state);
    const draft = structuredClone(this.state);
    mutator(draft);
    this.state = draft;
    for (const listener of this.listeners) listener(this.state, previous);
  }

  replace(next: AppState): void {
    const previous = structuredClone(this.state);
    this.state = structuredClone(next);
    for (const listener of this.listeners) listener(this.state, previous);
  }

  subscribe(listener: StoreListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
